import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'odq-address-input',
    templateUrl: './address-input.component.html',
    styleUrls: ['./address-input.component.scss'],
    standalone: false
})
export class AddressInputComponent implements OnInit {

  constructor() { }

  @Input() parentForm: UntypedFormGroup;
  @Input() groupName: string;

  ngOnInit() { }

}
